import assign from 'lodash/assign';
import AgentActivity from 'models/agent_activity';
import { AgentAvailability } from 'models/agent_status';
import { handleErrorInteractively, setBusyPendingWithReason, updateStore } from 'actions/agent_status/lib/agent_status';
import { ReasonType } from 'models/agent_status_reason';
import { logStatusActivity } from 'actions/agent_status/lib/agent_activity';

export default class ReturnFromAway {
  constructor(context) {
    this.context = context;
  }

  run({ reasonId } = {}) {
    if (this.store.get().getAvailability() !== AgentAvailability.AWAY) {
      return;
    }

    let newStatus = assign({ availability: AgentAvailability.BUSY }, reasonId && { awayReasonId: reasonId });

    const defaultReason = this.context.stores.agentStatusReasons.findBy({
      filter: r => r.default && r.type === ReasonType.ACTIVE,
    });
    newStatus = assign(newStatus, { activeReasonId: defaultReason.id });
    setBusyPendingWithReason(this.context, defaultReason.id);

    this.context.gateways.agentStatus
      .update(newStatus)
      .then(response => this.handleSuccess(response))
      .catch(err => handleErrorInteractively(this.context, err));

    logStatusActivity(this.context, AgentActivity.Type.BUSY);
  }

  handleSuccess(response) {
    this.store.resetPending();
    updateStore(this.context, response);

    if (this.store.get().getAvailability() !== AgentAvailability.AWAY) {
      this.context.capacityManager.start();
    }
  }

  get store() {
    return this.context.stores.agentStatus;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/agent_status/return_from_away.js